import React from 'react';
import { HeroCTAButton } from './HeroCTAButton';
export function HeroSection() {
  return <section className="relative bg-navy-dark pt-0 pb-16 md:pb-24 overflow-hidden" data-id="element-186">
      {/* Urgency Bar */}
      <div className="bg-gold-primary text-navy-dark py-3 px-4 text-center font-bold text-sm md:text-base tracking-wide z-20 relative shadow-md" data-id="element-187">
        ⚠️ El IRS solo permite reclamar dinero de los últimos 3 años. Cada día
        que pasa, pierdes esa ventana.
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 relative z-10" data-id="element-188">
        <div className="text-center space-y-8" data-id="element-189">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight drop-shadow-lg font-heading" data-id="element-190">
            El IRS Ha Estado Guardando Tu Dinero Por Años — Aquí Está Cómo
            Reclamarlo Antes de Que Sea Demasiado Tarde
          </h1>

          <h2 className="text-xl md:text-2xl text-gold-secondary font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-191">
            Descubre los 3 Hacks Legales Que El 90% de Contribuyentes Latinos
            Desconoce Para Maximizar Su Reembolso — Incluyendo Cómo Recuperar
            Dinero de Hasta 3 Años Atrás
          </h2>

          <div className="pt-8 pb-4 flex justify-center" data-id="element-192">
            <div className="relative w-full max-w-md mx-auto" data-id="element-193">
              <div className="absolute inset-0 bg-gold-primary/20 blur-3xl rounded-full" data-id="element-194"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1fF4Tm21S49eNCpVTbx8Sv/irsTeDebe.png" alt="El Dinero Que El IRS Te Debe - Guía Experta de Declaración" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-195" />
            </div>
          </div>

          <div className="pt-6" data-id="element-196">
            <HeroCTAButton data-id="element-197" />
            <p className="mt-4 text-sm text-gray-400 font-medium" data-id="element-198">
              Descarga inmediata • Pago seguro
            </p>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-20 pointer-events-none" data-id="element-199">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-light to-transparent rounded-full blur-3xl" data-id="element-200"></div>
      </div>
    </section>;
}